import { Component, ChangeDetectorRef, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import { GlobalConstants } from '../global-constants';

@Component({
  selector: 'app-ultimos-perfiles',
  templateUrl: './ultimos-perfiles.component.html',
  styleUrls: ['./ultimos-perfiles.component.css']
})
export class UltimosPerfilesComponent implements OnInit {
  misdatos: any = null;
  perfiles: any[] = [];
  busy = true;
  error = false;
  global: any = GlobalConstants;
  get ubicacionBusqueda(): string {
    return [this.misdatos?.barrio, this.misdatos?.ciudad]
      .filter((valor: any) => typeof valor === 'string' && !!valor.trim()).join(' · ');
  }
  @ViewChild('carrusel') carrusel?: ElementRef<HTMLElement>;
  paginaActual = 0;
  tarjetasPorPagina = 3;

  get paginas(): number[] {
    return Array.from({ length: Math.ceil(this.perfiles.length / this.tarjetasPorPagina) }, (_, i) => i);
  }
  get puedeAnterior(): boolean { return this.paginaActual > 0; }
  get puedeSiguiente(): boolean { return this.paginaActual < this.paginas.length - 1; }

  @HostListener('window:resize')
  alRedimensionar(): void {
    this.tarjetasPorPagina = window.innerWidth <= 600 ? 1 : window.innerWidth <= 900 ? 2 : 3;
    this.paginaActual = Math.min(this.paginaActual, Math.max(0, this.paginas.length - 1));
  }

  irPagina(pagina: number): void {
    const contenedor = this.carrusel?.nativeElement;
    if (!contenedor) return;
    const destino = Math.max(0, Math.min(pagina, this.paginas.length - 1));
    const tarjeta = contenedor.querySelector<HTMLElement>('.iguau-perfil-card');
    if (!tarjeta) return;
    const gap = parseFloat(getComputedStyle(contenedor).columnGap) || 0;
    contenedor.scrollTo({ left: destino * this.tarjetasPorPagina * (tarjeta.offsetWidth + gap), behavior: 'smooth' });
    this.paginaActual = destino;
  }
  avanzar(direccion: number): void { this.irPagina(this.paginaActual + direccion); }
  alDesplazar(): void {
    const contenedor = this.carrusel?.nativeElement;
    if (!contenedor || contenedor.clientWidth === 0) return;
    this.paginaActual = Math.min(Math.max(0,this.paginas.length - 1),
      Math.max(0, Math.round(contenedor.scrollLeft / contenedor.clientWidth)));
  }


  constructor(private query: QueryService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.alRedimensionar();
    this.getMisDatos();
  }

  getMisDatos(): void {
    this.busy = true;
    this.error = false;
    this.query.query('misdatos', 'GET', null).subscribe({
      next: (resultado: any) => {
        // El servicio puede devolver el usuario directamente o dentro de «registros».
        this.misdatos = resultado?.registros && !Array.isArray(resultado.registros)
          ? resultado.registros : resultado;
        // Invitados: GET devuelve los últimos perfiles públicos sin ubicación personalizada.
        this.getUltimosPerfiles();
      },
      error: () => {
        // misdatos puede responder 401 para invitados; no bloqueamos la portada pública.
        this.misdatos = null;
        this.getUltimosPerfiles();
      }
    });
  }

  getUltimosPerfiles(): void {
    this.busy = true;
    this.error = false;
    this.query.query('perfiles', 'GET', null).subscribe({
      next: (resultado: any) => {
        this.perfiles = resultado?.resultado === 'ERROR'
          ? [] : (Array.isArray(resultado?.registros) ? resultado.registros : []);
        this.error = resultado?.resultado === 'ERROR';
        this.paginaActual = 0;
        this.busy = false;
        this.cd.markForCheck();
      },
      error: () => {
        this.perfiles = [];
        this.busy = false;
        this.error = true;
        this.cd.markForCheck();
      }
    });
  }

  getPerfilUrl(perfil: any): string {
    const slug = String(perfil?.slug || '').trim();
    return this.global.urlServer.replace(/\/?$/, '/') + 'perfil/' + encodeURIComponent(slug) + '/';
  }

  getFotoMascota(perfil: any): string {
    return perfil?.mascota?.foto_principal_thumb || perfil?.foto_principal_thumb || '';
  }

  getFotoPerfil(perfil: any): string {
    return perfil?.foto_principal_thumb || '';
  }

  trackByPerfil(index: number, perfil: any): number | string {
    return perfil?.ID || perfil?.id || perfil?.slug || index;
  }
}
